module.exports = __webpack_public_path__ + "static/media/puzzle-piece.71296717.png";